<script>
export default {
    name: "AllPatientsReport",

    data() {

        return {
            filter: {
                pageSize: 10,
                page: 1,
                search: '',
            },
            patients: [],
        };
    },

    watch: {
        "filter.pageSize"() {
            this.fetchAll();
        },

        "filter.page"() {
            this.fetchAll();
        },
    },

    mounted() {

        this.fetchAll();
    },

    methods: {

        fetchAll() {

            this.$root.loading = true;
            let url = `PatientsReports/GetPatientListPagination?page=${this.filter.page}&pagesize=${this.filter.pageSize}`;
            url += this.filter.search ? `&SearchText=${this.filter.search}` : ``;
            this.$http.get(url).then(response => {
                this.patients = response.data;
                this.$root.loading = false;
            }).catch(() => {
                this.$root.loading = false;
            });
        },

        printAllPatients() {

            window.open(`/reports/patients/all-patients/print?page=${this.filter.page}&pageSize=${this.filter.pageSize}`, '_blank', `VisitPreview`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li><router-link :to="{name : 'reports.patients'}">Patient Reports</router-link></li>
             <li><span class="mx-2">/</span></li>
             <li>All Patients</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">All Patients</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-row">
              <div class="md:w-1/2 sm:w-full p-1">
                  <input v-model.trim="filter.search" @keydown.enter="fetchAll" type="text" id="grid-search" class="input-control input-sm text-xs" placeholder="Search">
              </div>
              <div class="md:w-1/12 sm:w-1/2 p-1 text-right">
                  <tail-select>
                      <template v-slot:field>
                          <select v-model="filter.pageSize" class="input-control input-sm text-xs">
                              <option :value="10">10</option>
                              <option :value="25">25</option>
                              <option :value="50">50</option>
                              <option :value="100">100</option>
                              <option :value="200">200</option>
                              <option :value="500">500</option>
                          </select>
                      </template>
                  </tail-select>
              </div>
              <div class="md:w-1/12 sm:w-1/2 flex flex-row">
                <div class="flex-1 whitespace-no-wrap">
                    <a href="javascript:void(0)"
                      class="text-blue-800 text-xs" 
                      @click.prevent="() => { if(filter.page <= 1) return; filter.page--; }">
                          <span><i class="fa fa-caret-left"></i> Previous</span>
                    </a>
                </div>
                <div class="text-sm font-bold w-16 my-px mx-1">
                    <input type="number" v-model="filter.page" disabled class="input-control input-sm text-xs text-right disabled">
                </div>
                <div class="flex-1 whitespace-no-wrap">
                    <a href="javascript:void(0)" class="text-blue-800 text-xs" @click.prevent="filter.page++">
                          <span>Next <i class="fa fa-caret-right"></i></span>
                    </a>
                </div>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny text-center -mt-px">
                  <button 
                    class="btn-sm btn-primary text-xs rounded" 
                    @click.prevent="$root.exportToExcel(`all-patients-report`, `allPatientsTable`)">
                        <i class="fa fa-file-excel"></i> Export</button>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny text-center -mt-px">
                  <button 
                    class="btn-sm btn-info text-xs rounded" 
                    @click.prevent="printAllPatients">
                        <i class="fa fa-print"></i> Print
                  </button>
              </div>
          </div>
          <div class="w-full overflow-auto">
              <table class="table table-hover" id="allPatientsTable">
                  <thead class="bg-blue-500 text-xs text-white">
                        <tr class="w-full flex">
                          <th class="p-tiny w-1/12">ID</th>
                          <th class="p-tiny w-1/3">Names</th>
                          <th class="p-tiny w-1/12">IP. NO.</th>
                          <th class="p-tiny w-1/12">OP NO</th>
                          <th class="p-tiny w-1/12">ID NO</th>
                          <th class="p-tiny w-1/6">DOB</th>
                          <th class="p-tiny w-1/12">Cell Phone</th>
                          <th class="p-tiny w-1/12">InPatient</th>
                          <th class="p-tiny w-1/12">Visits(s)</th>
                        </tr>
                  </thead>
                  <tfoot>
                      <tr class="w-full flex">
                          <th class="p-tiny w-1/2"></th>
                          <th class="p-tiny w-1/2 text-right">Total Patients: {{ patients.length }}</th>
                      </tr>
                  </tfoot>
                  <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height:70vh;">
                      <tr class="w-full flex" v-for="(patient, idx) in patients" :key="idx">
                          <td class="p-tiny w-1/12">{{ patient.patienT_ID }}</td>
                          <td class="p-tiny w-1/3">{{ patient.names }}</td>
                          <td class="p-tiny w-1/12">{{ patient.ipfileno }}</td>
                          <td class="p-tiny w-1/12">{{ patient.opfileno }}</td>
                          <td class="p-tiny w-1/12">{{ patient.nationalid }}</td>
                          <td class="p-tiny w-1/6">{{ patient.dob | dateFormat }}</td>
                          <td class="p-tiny w-1/12"><span class="ml-2">{{ patient.celL_PHONE }}</span></td>
                          <td class="p-tiny w-1/12"><span class="ml-3">{{ patient.iS_IN_PATIENT == `False` ? `No` : `Yes` }}</span></td>
                          <td class="p-tiny w-1/12"><span class="ml-3">{{ patient.visitCount }}</span></td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>